export default __webpack_public_path__ + "static/media/dark_close_icon.681db0b4.svg";